import AuthService from './auth'
import { TokenStorageService as tokenStorage, TokenTimingService as tokenTiming } from '../token'
import { companyStorage } from '../storage'
import { removeUserData } from '../user-data'
import { removeUserPermissions } from '../user-permissions'
import { api as libraryServicesApi } from '@/lib/services'

const client = {
    clientId: '2',
    clientSecret: process.env.VUE_APP_CLIENT_SECRET,
}
const environment = process.env.NODE_ENV

const userStorage = {
    removeUserData,
    removeUserPermissions,
}

export default AuthService(
    tokenStorage,
    userStorage,
    tokenTiming,
    companyStorage,
    environment,
    client,
    libraryServicesApi
)
